export default __webpack_public_path__ + "static/media/like_btn.bb7b7ba8.svg";